import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemDescription } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDescription/ItemDescription";
import { ItemStockAndEds } from "@coworker/apprestructured/src/shared/components/item-cards/ItemStockAndEds/ItemStockAndEds";
import { ItemDelivery } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDelivery/ItemDelivery";
import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { ItemNoWithCopy } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNoWithCopy/ItemNoWithCopy";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import styles from "../../../styles/common-styles.module.css";

interface ItemCardWithCopyNoProps {
  item: Item & { quantity?: number };
  onCopy?: () => void;
}

export const ItemCardWithCopyNo = ({
  item,
  onCopy,
}: ItemCardWithCopyNoProps) => {
  const { t } = useTranslation();
  return (
    <ItemCard>
      <div className={styles["item-card-root-row"]}>
        <ItemImage imageUrl={item.smallImageUrl || item.imageUrl || ""} />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={item.name} />
          <ItemNoWithCopy itemNo={item.noFormatted} onCopy={onCopy} />
          <ItemDescription description={item.description || ""} />
          {item.quantity && (
            <FixaText textStyle="Body.M">
              <strong>
                {t("piecesCountString", { count: item.quantity })}
              </strong>
            </FixaText>
          )}
          <ItemStockAndEds itemNo={item.no} itemType={item.type} />
          <ItemDelivery itemNo={item.no} />
        </div>
      </div>
    </ItemCard>
  );
};
